import { render, staticRenderFns } from "./registerPay.vue?vue&type=template&id=5ecb7430&scoped=true&"
import script from "./registerPay.vue?vue&type=script&lang=js&"
export * from "./registerPay.vue?vue&type=script&lang=js&"
import style0 from "./registerPay.vue?vue&type=style&index=0&id=5ecb7430&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecb7430",
  null
  
)

export default component.exports